// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#eyeb {
  transform: translateY(-9px);
  animation: eyeb 5s linear infinite;
}

@keyframes eyeb {
  0% {
    transform: translateY(-10);
    -ms-transform: translateY(-10);
    -moz-transform: translateY(-10);
  }

  25% {
    transform: translateY(0px);
    -ms-transform: translateY(0px);
    -moz-transform: translateY(0px);
  }

  75% {
    transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }

  100% {
    transform: translateY(10);
    -moz-transform: translateY(10);
    -ms-transform: translateY(10);
  }
}

#mouth {
  transform: translateY(-5px);
  -ms-transform: translateY(-5px);
  -moz-transform: translateY(-5px);
  animation: mouth 5s linear infinite;
}

@keyframes mouth {
  0% {
    transform: translateY(-10);
    -ms-transform: translateY(-10);
    -moz-transform: translateY(-10);
  }

  25% {
    transform: translateY(0px);
    -ms-transform: translateY(0px);
    -moz-transform: translateY(0px);
  }

  75% {
    transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }

  100% {
    transform: translateY(10);
    -moz-transform: translateY(10);
    -ms-transform: translateY(10);
  }
}

#eyey2 {
  transform: translateX(-2px);
  -moz-transform: translateX(-2px);
  -ms-transform: translateX(-2px);
  animation: eyey2 4s linear infinite;
}

@keyframes eyey2 {
  0% {
    transform: translateX(-2);
    -ms-transform: translateX(-2);
    -moz-transform: translateX(-2);
  }

  25% {
    transform: translateX(2px);
    -moz-transform: translateX(2px);
    -ms-transform: translateX(2px);
  }

  75% {
    transform: translateX(-2px);
    -ms-transform: translateX(-2px);
    -moz-transform: translateX(-2px);
  }

  100% {
    transform: translateX(2);
    -ms-transform: translateX(2);
    -moz-transform: translateX(2);
  }
}

#notebook {
  transform: translateY(-4px);
  -moz-transform: translateY(-4px);
  -ms-transform: translateY(-4px);
  animation: notebook 6s linear infinite;
}

@keyframes notebook {
  0% {
    transform: translateY(-4);
  }

  25% {
    transform: translateY(0px);
  }

  75% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(4);
  }
}

#legs {
  transform: translateY(-9px);
  animation: legs 6s infinite;
}

@keyframes legs {
  0% {
    transform: translateY(-10);
    -ms-transform: translateY(-10);
    -moz-transform: translateY(-10);
  }

  25% {
    transform: translateY(0px);
    -ms-transform: translateY(0px);
    -moz-transform: translateY(0px);
  }

  75% {
    transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }

  100% {
    transform: translateY(10);
    -moz-transform: translateY(10);
    -ms-transform: translateY(10);
  }
}

#pe {
  animation: pe 6s infinite;
}

@keyframes pe {
  0% {
    transform: rotateX(2deg);
    -ms-transform: rotateX(2deg);
    -moz-transform: rotateX(2deg);
  }
}

#shirt {
  transform: translateY(-9px);
  -ms-transform: translateY(-9px);
  -moz-transform: translateY(-9px);
  animation: shirt 6s infinite;
}

@keyframes shirt {
  0% {
    transform: translateY(-10);
    -ms-transform: translateY(-10);
    -moz-transform: translateY(-10);
  }

  25% {
    transform: translateY(0px);
    -ms-transform: translateY(0px);
    -moz-transform: translateY(0px);
  }

  75% {
    transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }

  100% {
    transform: translateY(10);
    -moz-transform: translateY(10);
    -ms-transform: translateY(10);
  }
}

#tshirt {
  transform: translateY(-9px);
  -ms-transform: translateY(-9px);
  -moz-transform: translateY(-9px);
  animation: tshirt 6s infinite;
}

@keyframes tshirt {
  0% {
    transform: translateY(-10);
    -ms-transform: translateY(-10);
    -moz-transform: translateY(-10);
  }

  25% {
    transform: translateY(0px);
    -ms-transform: translateY(0px);
    -moz-transform: translateY(0px);
  }

  75% {
    transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }

  100% {
    transform: translateY(10);
    -moz-transform: translateY(10);
    -ms-transform: translateY(10);
  }
}

#head {
  transform: translateY(-9px);
  -ms-transform: translateY(-9px);
  -moz-transform: translateY(-9px);
  animation: head 6s infinite;
}

@keyframes head {
  0% {
    transform: translateY(-8);
  }

  25% {
    transform: translateY(0px);
  }

  75% {
    transform: translateY(0px);
  }

  100% {
    transform: translateY(8);
  }
}

#ears {
  animation: ears 6s linear infinite;
}

@keyframes ears {
  0% {
    transform: translateY(-10);
    -ms-transform: translateY(-10);
    -moz-transform: translateY(-10);
  }

  25% {
    transform: translateY(0px);
    -ms-transform: translateY(0px);
    -moz-transform: translateY(0px);
  }

  75% {
    transform: translateY(0px);
    -moz-transform: translateY(0px);
    -ms-transform: translateY(0px);
  }

  100% {
    transform: translateY(10);
    -moz-transform: translateY(10);
    -ms-transform: translateY(10);
  }
}

#brows {
  animation: brows 6.1s linear infinite;
}

@keyframes brows {
  0% {
    transform: scale(0.96);
  }

  25% {
    transform: scale(1);
  }

  75% {
    transform: scale(1);
  }

  100% {
    transform: scale(0.96);
  }
}
`, "",{"version":3,"sources":["webpack://./src/containers/greeting/FeelingProud.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;EAC/B;AACF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;EAC/B;AACF;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,mCAAmC;AACrC;;AAEA;EACE;IACE,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;EAChC;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;IAC3B,+BAA+B;IAC/B,gCAAgC;EAClC;;EAEA;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;EAC/B;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,wBAAwB;IACxB,4BAA4B;IAC5B,6BAA6B;EAC/B;AACF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;EAC/B;AACF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;EAC/B;AACF;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,8BAA8B;IAC9B,+BAA+B;EACjC;;EAEA;IACE,0BAA0B;IAC1B,+BAA+B;IAC/B,8BAA8B;EAChC;;EAEA;IACE,yBAAyB;IACzB,8BAA8B;IAC9B,6BAA6B;EAC/B;AACF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["#eyeb {\n  transform: translateY(-9px);\n  animation: eyeb 5s linear infinite;\n}\n\n@keyframes eyeb {\n  0% {\n    transform: translateY(-10);\n    -ms-transform: translateY(-10);\n    -moz-transform: translateY(-10);\n  }\n\n  25% {\n    transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n  }\n\n  75% {\n    transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(10);\n    -moz-transform: translateY(10);\n    -ms-transform: translateY(10);\n  }\n}\n\n#mouth {\n  transform: translateY(-5px);\n  -ms-transform: translateY(-5px);\n  -moz-transform: translateY(-5px);\n  animation: mouth 5s linear infinite;\n}\n\n@keyframes mouth {\n  0% {\n    transform: translateY(-10);\n    -ms-transform: translateY(-10);\n    -moz-transform: translateY(-10);\n  }\n\n  25% {\n    transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n  }\n\n  75% {\n    transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(10);\n    -moz-transform: translateY(10);\n    -ms-transform: translateY(10);\n  }\n}\n\n#eyey2 {\n  transform: translateX(-2px);\n  -moz-transform: translateX(-2px);\n  -ms-transform: translateX(-2px);\n  animation: eyey2 4s linear infinite;\n}\n\n@keyframes eyey2 {\n  0% {\n    transform: translateX(-2);\n    -ms-transform: translateX(-2);\n    -moz-transform: translateX(-2);\n  }\n\n  25% {\n    transform: translateX(2px);\n    -moz-transform: translateX(2px);\n    -ms-transform: translateX(2px);\n  }\n\n  75% {\n    transform: translateX(-2px);\n    -ms-transform: translateX(-2px);\n    -moz-transform: translateX(-2px);\n  }\n\n  100% {\n    transform: translateX(2);\n    -ms-transform: translateX(2);\n    -moz-transform: translateX(2);\n  }\n}\n\n#notebook {\n  transform: translateY(-4px);\n  -moz-transform: translateY(-4px);\n  -ms-transform: translateY(-4px);\n  animation: notebook 6s linear infinite;\n}\n\n@keyframes notebook {\n  0% {\n    transform: translateY(-4);\n  }\n\n  25% {\n    transform: translateY(0px);\n  }\n\n  75% {\n    transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(4);\n  }\n}\n\n#legs {\n  transform: translateY(-9px);\n  animation: legs 6s infinite;\n}\n\n@keyframes legs {\n  0% {\n    transform: translateY(-10);\n    -ms-transform: translateY(-10);\n    -moz-transform: translateY(-10);\n  }\n\n  25% {\n    transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n  }\n\n  75% {\n    transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(10);\n    -moz-transform: translateY(10);\n    -ms-transform: translateY(10);\n  }\n}\n\n#pe {\n  animation: pe 6s infinite;\n}\n\n@keyframes pe {\n  0% {\n    transform: rotateX(2deg);\n    -ms-transform: rotateX(2deg);\n    -moz-transform: rotateX(2deg);\n  }\n}\n\n#shirt {\n  transform: translateY(-9px);\n  -ms-transform: translateY(-9px);\n  -moz-transform: translateY(-9px);\n  animation: shirt 6s infinite;\n}\n\n@keyframes shirt {\n  0% {\n    transform: translateY(-10);\n    -ms-transform: translateY(-10);\n    -moz-transform: translateY(-10);\n  }\n\n  25% {\n    transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n  }\n\n  75% {\n    transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(10);\n    -moz-transform: translateY(10);\n    -ms-transform: translateY(10);\n  }\n}\n\n#tshirt {\n  transform: translateY(-9px);\n  -ms-transform: translateY(-9px);\n  -moz-transform: translateY(-9px);\n  animation: tshirt 6s infinite;\n}\n\n@keyframes tshirt {\n  0% {\n    transform: translateY(-10);\n    -ms-transform: translateY(-10);\n    -moz-transform: translateY(-10);\n  }\n\n  25% {\n    transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n  }\n\n  75% {\n    transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(10);\n    -moz-transform: translateY(10);\n    -ms-transform: translateY(10);\n  }\n}\n\n#head {\n  transform: translateY(-9px);\n  -ms-transform: translateY(-9px);\n  -moz-transform: translateY(-9px);\n  animation: head 6s infinite;\n}\n\n@keyframes head {\n  0% {\n    transform: translateY(-8);\n  }\n\n  25% {\n    transform: translateY(0px);\n  }\n\n  75% {\n    transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(8);\n  }\n}\n\n#ears {\n  animation: ears 6s linear infinite;\n}\n\n@keyframes ears {\n  0% {\n    transform: translateY(-10);\n    -ms-transform: translateY(-10);\n    -moz-transform: translateY(-10);\n  }\n\n  25% {\n    transform: translateY(0px);\n    -ms-transform: translateY(0px);\n    -moz-transform: translateY(0px);\n  }\n\n  75% {\n    transform: translateY(0px);\n    -moz-transform: translateY(0px);\n    -ms-transform: translateY(0px);\n  }\n\n  100% {\n    transform: translateY(10);\n    -moz-transform: translateY(10);\n    -ms-transform: translateY(10);\n  }\n}\n\n#brows {\n  animation: brows 6.1s linear infinite;\n}\n\n@keyframes brows {\n  0% {\n    transform: scale(0.96);\n  }\n\n  25% {\n    transform: scale(1);\n  }\n\n  75% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(0.96);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
